module.exports = __webpack_public_path__ + "static/media/open-sans-v15-latin-600.223a277b.woff2";